module.exports = __webpack_public_path__ + "static/media/moment06.bc820921.webp";